import { IELTFinancialData } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { IMeetingMainInfo } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { IPartnerGroupAdditionalInfo } from 'legacy/lut/components/widgets/public/partner360/ELT/models/IPartnerGroupAdditionalInfo'

import { getAdminContactData } from './contacts/getAdminContactData'
import { getHpContactData } from './contacts/getHpContactData'
import { getCompanyContactData } from './contacts/getPrimaryContactData'

export const getMainInfoInitialData = (
  partnerGroupData: IPartnerGroupAdditionalInfo | null,
  financialData: IELTFinancialData | null
): IMeetingMainInfo => {
  const hpExecutiveSponsor = {
    HpExecutiveSponsor: partnerGroupData?.hpSponsorName || '',
  } as IMeetingMainInfo

  if (!financialData) {
    return hpExecutiveSponsor
  }

  const { HPContact, PrimaryContact, AdminContact } = financialData

  return {
    ...hpExecutiveSponsor,
    ...getHpContactData(HPContact),
    ...getCompanyContactData(PrimaryContact),
    ...getAdminContactData(AdminContact),
  } as IMeetingMainInfo
}
